var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "new_top" },
        [_c("header2"), _vm._v(" "), _c("navigation", { ref: "navigation" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sy_main" }, [
        _c("div", { staticClass: "sym_content2" }, [
          _c("div", { staticClass: "symc2" }, [
            _c("div", { staticClass: "symc2_box" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "symc2_box_main",
                  staticStyle: { "font-style": "normal" }
                },
                [
                  _c(
                    "ul",
                    _vm._l(_vm.newsList, function(item, index) {
                      return (_vm.settings.isSubject && index > 0) ||
                        !_vm.settings.isSubject
                        ? _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "new_num_list", attrs: { id: "coursePageUl" } },
                [
                  _c("el-pagination", {
                    attrs: {
                      small: "true",
                      "current-page": _vm.settings.pageNum,
                      "page-size": _vm.settings.pageSize,
                      layout: "prev, pager, next, jumper",
                      total: _vm.total
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function($event) {
                        return _vm.$set(_vm.settings, "pageNum", $event)
                      },
                      "update:current-page": function($event) {
                        return _vm.$set(_vm.settings, "pageNum", $event)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "symc_right" },
            [_c("login"), _vm._v(" "), _c("latestNewsSimple")],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", {})
      ]),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "symc2_box_title" }, [
      _c("img", {
        attrs: {
          src: require("../assets/img/secondary_h3_pic.gif"),
          width: "21",
          height: "15"
        }
      }),
      _c("a", { attrs: { href: "javascript:;" } }, [_vm._v("站内搜索")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69276162", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69276162","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MedicalSearch.vue
// module id = null
// module chunks = 